import * as React from "react";
import cn from "clsx";
import { Tag, TagProps } from "../tag";

export type TagCollectionProps = {
  tags: TagProps[] | string[]
  
} & React.ButtonHTMLAttributes<HTMLDivElement>;

const TagCollection = React.forwardRef<HTMLDivElement, TagCollectionProps>(
  ({ className, tags }, ref) => {
    return (
        <div className={cn("in-tag-collection", className)}>
        {tags.map((tag) => (
          <Tag key={tag.content || tag} content={tag.content || tag} iconName={tag.iconName || undefined} />
        ))}
      </div>
    );
  }
);

export { TagCollection };
